import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";

const createCampaign = (_, params) => {
  return Api(ENDPOINTS.CAMPAIGN.CREATE, params, requestType.POST);
};

const getAllCampaigns = (params) => {
  const url = ENDPOINTS.CAMPAIGN.GET_ALL;
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append("page", params.page);
  if (params?.limit) queryParams.append("limit", params.limit);
  if (params?.search) queryParams.append("search", params.search);
  if (params?.status) queryParams.append("status", params.status);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;

  return Api(finalUrl, null, requestType.GET);
};

const getCampaignById = (id) => {
  return Api(
    ENDPOINTS.CAMPAIGN.GET_BY_ID.replace(":id", id),
    null,
    requestType.GET
  );
};

const updateCampaign = (id, params) => {
  return Api(
    ENDPOINTS.CAMPAIGN.UPDATE.replace(":id", id),
    params,
    requestType.PUT
  );
};

const deleteCampaign = (id) => {
  return Api(
    ENDPOINTS.CAMPAIGN.DELETE.replace(":id", id),
    null,
    requestType.DELETE
  );
};

const publishCampaign = (id) => {
  return Api(
    ENDPOINTS.CAMPAIGN.PUBLISH.replace(":id", id),
    null,
    requestType.PUT
  );
};

const closeCampaign = (id) => {
  return Api(
    ENDPOINTS.CAMPAIGN.CLOSE.replace(":id", id),
    null,
    requestType.PUT
  );
};

const getCampaignParticipants = (id, params) => {
  const queryParams = new URLSearchParams();
  if (params?.status) queryParams.append("status", params.status);
  const url = ENDPOINTS.CAMPAIGN.PARTICIPANTS.replace(":id", id);
  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const updateCampaignParticipantStatus = (id, params) => {
  return Api(
    ENDPOINTS.CAMPAIGN.UPDATE_PARTICIPANT_STATUS.replace(":id", id),
    params,
    requestType.PUT
  );
};

const reviewCampaignSubmission = (id, params) => {
  return Api(
    ENDPOINTS.CAMPAIGN.REVIEW_SUBMISSION.replace(":id", id),
    params,
    requestType.PUT
  );
};

export {
  createCampaign,
  getAllCampaigns,
  getCampaignById,
  updateCampaign,
  deleteCampaign,
  publishCampaign,
  closeCampaign,
  getCampaignParticipants,
  updateCampaignParticipantStatus,
  reviewCampaignSubmission,
};
